module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel01_770_280_en-d9c035cf7195d117c363f67f0347c82e.jpg";